import { render, staticRenderFns } from "./DelegatedAccounts.vue?vue&type=template&id=0350c42b&"
import script from "./DelegatedAccounts.vue?vue&type=script&lang=js&"
export * from "./DelegatedAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0350c42b')) {
      api.createRecord('0350c42b', component.options)
    } else {
      api.reload('0350c42b', component.options)
    }
    module.hot.accept("./DelegatedAccounts.vue?vue&type=template&id=0350c42b&", function () {
      api.rerender('0350c42b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/DelegatedAccounts.vue"
export default component.exports